import { useEffect } from 'react';
import { useLocation } from 'react-router-dom-v5-compat';

/** Leave the marketing SPA so ingress can serve the current SEO homepage. */
export const CanonicalHomeRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const locale = pathname.match(/^\/(en|fr|es)(?:\/|$)/)?.[1];
  const destination = `/${locale ?? ''}${search}${hash}`;

  useEffect(() => {
    // A router redirect would stay in this SPA and render the retired homepage.
    window.location.replace(destination);
  }, [destination]);

  return null;
};
